module.exports = __webpack_public_path__ + "img/buddy_nose-05.a816f686.svg";